import { forwardRef } from "react";
import type { IconProps } from "@tabler/icons-react";

export const IconCollection = forwardRef<SVGSVGElement, IconProps>(
  (
    {
      color = "currentColor",
      size = 24,
      stroke = 2,
      title,
      className,
      ...rest
    },
    ref
  ) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={["tabler-icon", "tabler-icon-collection", className]
        .filter((c) => c !== undefined)
        .join(" ")}
      {...rest}
    >
      {title === undefined ? null : <title>{title}</title>}
      <path d="M4.92857 6.00014H19.0714M6.85714 3.00098H17.1429M3 8.78607H21L18.4286 20.3575C13.4075 20.3575 10.5925 20.3575 5.57143 20.3575L3 8.78607Z" />
    </svg>
  )
);
IconCollection.displayName = "IconCollection";
